import { rememberTlLinkLogo } from "./tron-designer/tl-logo-handover";

export default class TronLogoLinks {

    init(): void {
        this.initTronLogo();
    }

    private initTronLogo() {
        let tronLogoGUID = '';
        try {
            const WebUrl = new URL(window.location.href);
            tronLogoGUID = WebUrl.searchParams.get("tlgd");
            if (!tronLogoGUID) { tronLogoGUID = "" }
        } catch (err) { }

        // §5.2 — pin the TL-link logo to the session so the TD editor can import it later in the flow
        // (the TL engine only gets it for the visualization below).
        if (tronLogoGUID) {
            rememberTlLinkLogo(tronLogoGUID);
        }

        window.setTimeout(() => this.tronLogoCheckActivate(0, tronLogoGUID), 250);

    }

    private tronLogoCheckActivate(tronLogoCheckCounter: number, tronLogoGUID: string) {
        if (window.tronlogo != undefined) {
            if (tronLogoGUID) {
                window.tronlogo.setCurrentLogo(tronLogoGUID);
            }
        } else {
            tronLogoCheckCounter = tronLogoCheckCounter + 1;
            if (tronLogoCheckCounter < 25) {
                window.setTimeout(() => this.tronLogoCheckActivate(0, tronLogoGUID), 250);
            }
        }
    }

}



